import React, { RefObject, useMemo } from 'react';

import InteractiveArticle from '@components/molecules/interactiveContent/interactiveArticle';
import InteractiveEssay from '@components/molecules/interactiveContent/interactiveEssay';
import InteractiveFillBlank from '@components/molecules/interactiveContent/interactiveFillBlank';
import InteractiveMultipleChoice from '@components/molecules/interactiveContent/interactiveMultipleChoice';
import InteractiveMultipleChoose from '@components/molecules/interactiveContent/interactiveMultipleChoose';
import { IInteractiveContent, InteractionType } from '@interfaces/learning';

export type InteractiveContentProps = {
  interactiveContent: IInteractiveContent;
  isOpen?: boolean;
  onClose?: () => void;
  isPreview?: boolean;
  containerRef: RefObject<HTMLElement | undefined>;
};

const InteractiveContent = (props: InteractiveContentProps) => {
  const isOpen = !!props.isOpen;
  const { interaction_type } = props.interactiveContent;

  const interactiveContent = () => ({
    [InteractionType.ARTICLE]: <InteractiveArticle open={isOpen} {...props} />,
    [InteractionType.ESSAY]: <InteractiveEssay open={isOpen} {...props} />,
    [InteractionType.MULTIPLE_CHOOSE]: <InteractiveMultipleChoose open={isOpen} {...props} />,
    [InteractionType.MULTIPLE_CHOICES]: <InteractiveMultipleChoice open={isOpen} {...props} />,
    [InteractionType.FILL_IN_THE_BLANK]: <InteractiveFillBlank open={isOpen} {...props} />,
  });

  return interactiveContent()[interaction_type] || <></>;
};

export default InteractiveContent;
